import { Box } from '@material-ui/core';
import React from 'react';
import { PaymentCardPanel } from '../../PaymentCard';

export const renderEmiter = (image_url: string, name: string, isDownSm: boolean) => (
  <Box my={1} mx={isDownSm ? 0 : 1}>
    <PaymentCardPanel width="60px" widthImg="50px" image={image_url} nameId={name} mobile={isDownSm} />
  </Box>
);
